/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Form,
  message,
  Radio,
  TimePicker,
  Spin,
  Select,
  Checkbox,
} from "antd";
import {
  checkAlphabets,
  checkNumbervalue,
  checkSpace,
  checkSpecialCharacter,
} from "../../../../../utils";
import { APIs, getToken } from "../../../../../utils/worker";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getClientOnboard,
  patchClientOnboard,
  patchClientOnboardClear,
} from "../../../../../actionsMethods/onboardingMethods";
import x_icon from "../../../../../assests/images/SVG/removeItem.svg";
import moment from "moment";
import Smcs_Loader from "../../../../../assests/images/loader-new.gif";
import AutoCompleteAddress from "../../../../FirstMile/CrediteBooking/AutoCompleteAddress";
import PinCodeValidator from "../../../../../components/PincodeValidator";
import { validateClientOrgDetails } from "../../../../LeadGenerationCP/AggreementDetails/validateFields";

// import "../../style.scss";

export const OrganisationDetails = ({
  handleStepsChange = () => {},
  goBackStep = () => {},
  patchClient,
  getData,
  goToStep = () => {},
}) => {
  const [form] = Form.useForm();
  const [companyData, setCompanyData] = useState([]);
  const [departmentName, setDepartmentName] = useState(true);
  const [billingAddress, setBillingAddress] = useState(false);

  const [pickupTime, setPickupTime] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    //if (getData?.contacts?.[0]?.contactPersonName) {
    let { businessDetail, contacts, addresses } = getData || {};

    const officeAddress = addresses?.find(
      (e) => e?.type?.toLowerCase() === "office"
    );
    const billingAddress = addresses?.find(
      (e) => e?.type?.toLowerCase() === "billing"
    );

    form.setFieldsValue({
      natureOfBusiness: businessDetail?.natureOfBusiness,
      sez: businessDetail?.isSez,
      businessVolume: businessDetail?.turnOver,
      isCentralized: businessDetail?.isCentralized,
      pickUpTime: businessDetail?.pickUpTime
        ? moment(businessDetail.pickUpTime, "h A")
        : null,
      contactPersonName: contacts?.[0]?.contactPersonName,
      designation: contacts?.[0]?.designation,
      departmentName: contacts?.[0]?.departmentName,
      collectionAddress1: officeAddress?.street,
      collectionAddress2: officeAddress?.area,
      postalCodeCollection: officeAddress?.pincode,
      billingAddressLine1: billingAddress?.street,
      billingAddressLine2: billingAddress?.area,
      postalCodeBilling: billingAddress?.pincode,
    });
    //}
  }, [getData]);

  useEffect(() => {
    form.setFieldValue("centeralized", false);
    form.setFieldValue("sez", false);
  }, []);

  const onChange = (time, timeString) => {
    // const date = moment(time._d, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    // const formattedDate = date.format("DD-MM-YYYY HH:mm:ss");
    // const amPm = time.format("A");
    // console.log(amPm, timeString);

    setPickupTime(timeString);
  };

  function handleAreaDel(params) {
    let delAreas = companyData?.filter((val, idx) => params !== idx);
    setCompanyData(delAreas);
  }

  const createOrgDetails = (val) => {
    let payload = {
      businessDetail: {
        natureOfBusiness: val?.natureOfBusiness,
        isSez: val?.sez,
        turnOver: val?.businessVolume,
        isCentralized: val?.isCentralized,
        pickUpTime: pickupTime,
      },
      contacts: [
        {
          contactPersonName: val?.contactPersonName,
          designation: val?.designation,
          departmentName: val?.departmentName,
        },
      ],
      addresses: [
        {
          type: "office",
          street: val?.collectionAddress1,
          area: val?.collectionAddress2,
          pincode: val?.postalCodeCollection,
        },
        {
          type: "billing",
          street: billingAddress
            ? val?.collectionAddress1
            : val?.billingAddressLine1,
          area: billingAddress
            ? val?.collectionAddress2
            : val?.billingAddressLine2,
          pincode: billingAddress
            ? val?.postalCodeCollection
            : val?.postalCodeBilling,
        },
      ],
    };
    if (validateClientOrgDetails(getData)) {
      message.error("Fill all the required fields");
      goToStep(0);
      return;
    }
    patchClient(payload);
  };

  return (
    <Spin
      spinning={loading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div>
        <div>
          <Form
            className="global-form profile-container-form pl-4 pr-4"
            layout="vertical"
            form={form}
            scrollToFirstError={{
              behavior: "smooth",
              block: "center",
              inline: "center",
            }}
            initialValues={{
              businessVolume: 0,
              isCentralized: true,
            }}
            onFinish={createOrgDetails}
          >
            <Row gutter={40} className="global-form-row">
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="contactPersonName"
                  label="Contact name"
                  // rules={[
                  //   {
                  //     message: "Please enter contact name",
                  //     required: true,
                  //   },
                  // ]}
                  onKeyPress={(e) => {
                    if (/[^A-Za-z/ ]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (e.target.value.length >= 20) {
                      e.preventDefault();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (!/[a-zA-Z]/.test(e.target.value)) e.target.value = "";
                  }}
                >
                  <Input
                    // style={{ textTransform: "capitalize" }}
                    placeholder="Enter contact name"
                    maxLength={30}
                    disabled={getData?.status?.toLowerCase() === "approved"}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="designation"
                  label="Designation"
                  rules={[
                    {
                      message: "Please enter designation",
                      required: true,
                    },
                    {
                      pattern: /^([A-Za-z]{1}[A-Za-z0-9 ]{0,29})$/g,
                      message: "Designation can't be start with space",
                    },
                  ]}
                  onKeyPress={(e) => {
                    if (checkAlphabets(e)) {
                      e.preventDefault();
                    }
                    if (e.target.value.length >= 30) {
                      e.preventDefault();
                    }
                  }}
                >
                  <Input
                    placeholder="Enter designation"
                    style={{ textTransform: "capitalize" }}
                    disabled={getData?.status?.toLowerCase() === "approved"}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="departmentName"
                  label={"Department name"}
                  rules={[
                    {
                      required: companyData?.length ? false : true,
                      message: "Please enter department name",
                    },
                  ]}
                >
                  <Input
                    style={{
                      width: "100%",
                    }}
                    className="tag-items"
                    placeholder="Enter department name"
                    onKeyPress={(e) => {
                      if (/[^A-Za-z0-9-/ ]/.test(e.key)) {
                        e.preventDefault();
                      }
                      if (e.target.value.length >= 20) {
                        e.preventDefault();
                      }
                    }}
                    onKeyDown={(e) => {
                      if (!/[a-zA-Z0-9]/.test(e.target.value))
                        e.target.value = "";
                    }}
                    disabled={getData?.status?.toLowerCase() === "approved"}
                  />
                </Form.Item>

                {companyData?.length > 0 && (
                  <div className="area-list-box mb-1">
                    {companyData?.map((val, idx) => {
                      return (
                        <>
                          <div className="area-list-item" key={idx}>
                            {val}
                            <span
                              onClick={() => handleAreaDel(idx)}
                              className="pointer"
                              style={{ marginLeft: "10px" }}
                            >
                              <img src={x_icon} alt="X" width={11} />
                            </span>
                          </div>
                        </>
                      );
                    })}
                  </div>
                )}
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="natureOfBusiness"
                  label="Nature of business"
                  rules={[
                    {
                      message: "Please enter nature of business",
                      required: true,
                    },
                  ]}
                  onKeyPress={(e) => {
                    if (checkAlphabets(e) || checkSpecialCharacter(e)) {
                      e.preventDefault();
                    }
                  }}
                >
                  <Input
                    placeholder="Nature of business"
                    disabled={getData?.status?.toLowerCase() === "approved"}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="sez"
                  label={"Is SEZ"}
                  rules={[
                    {
                      required: true,
                      message: "Please select Is SEZ",
                    },
                  ]}
                >
                  <Radio.Group
                    className="calculater-container-div-radio"
                    disabled={getData?.status?.toLowerCase() === "approved"}
                  >
                    <Radio value={true} className="radioButton">
                      Yes
                    </Radio>
                    <Radio value={false} className="radioButton">
                      No
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="isCentralized"
                  label={"Centralized"}
                  rules={[
                    {
                      required: true,
                      message: "Please select centeralized",
                    },
                  ]}
                >
                  <Radio.Group
                    // onChange={(e) => scrolltoBottom(e)}
                    className="calculater-container-div-radio"
                    // disabled={createChildShipmentResult !== null && true}
                    disabled={getData?.status?.toLowerCase() === "approved"}
                  >
                    <Radio value={true} className="radioButton">
                      Yes
                    </Radio>
                    <Radio value={false} className="radioButton">
                      No
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="pickUpTime"
                  label="Pickup time"
                  rules={[
                    {
                      message: "Please select time",
                      required: true,
                    },
                  ]}
                  className="pickup-time-style"
                >
                  {/* <Input placeholder="Enter pickup time" /> */}
                  <TimePicker
                    use12Hours
                    format="hh:mm A"
                    onChange={onChange}
                    disabled={getData?.status?.toLowerCase() === "approved"}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="businessVolume"
                  label="Committed business volume per month"
                  rules={[
                    {
                      required: true,
                      message: "Please enter business volume",
                    },
                    {
                      pattern: /^([1-9]{1}[0-9]{0,9})$/g,
                      message: "Volume can't be 0",
                    },
                  ]}
                  onKeyPress={(e) => {
                    if (/[^0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (e.target.value.length >= 10) {
                      e.preventDefault();
                    }
                  }}
                >
                  <Input
                    placeholder="Value(INR)"
                    type="number"
                    disabled={getData?.status?.toLowerCase() === "approved"}
                  />
                </Form.Item>
              </Col>
              <Col span={24} className="mt-1 mb-1">
                <span className="master-title">Collection center Address </span>
                <hr className="divider" />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <AutoCompleteAddress
                  form={form}
                  returnAddress={false}
                  alertData={null}
                  fieldName="collectionAddress1"
                  label="Collection center street"
                  rules={[
                    {
                      required: true,
                      message: "Enter street",
                    },
                  ]}
                  disabled={getData?.status?.toLowerCase() === "approved"}
                />
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <AutoCompleteAddress
                  form={form}
                  returnAddress={false}
                  alertData={null}
                  fieldName="collectionAddress2"
                  label="Collection center address"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Enter area",
                  //   },
                  // ]}
                  disabled={getData?.status?.toLowerCase() === "approved"}
                />
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <PinCodeValidator
                  formName={"postalCodeCollection"}
                  label={"Collection center pincode"}
                  disabled={getData?.status?.toLowerCase() === "approved"}
                />
              </Col>

              <Col span={24} className="mt-1 mb-1">
                <Checkbox
                  onChange={() => {
                    setBillingAddress(!billingAddress);
                  }}
                  disabled={getData?.status?.toLowerCase() === "approved"}
                >
                  Is billing address same as collection address ?
                </Checkbox>
              </Col>

              {!billingAddress ? (
                <>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <AutoCompleteAddress
                      form={form}
                      returnAddress={false}
                      alertData={null}
                      fieldName="billingAddressLine1"
                      label="Billing street"
                      rules={[
                        {
                          required: true,
                          message: "Enter Billing street",
                        },
                      ]}
                      disabled={getData?.status?.toLowerCase() === "approved"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <AutoCompleteAddress
                      form={form}
                      returnAddress={false}
                      alertData={null}
                      fieldName="billingAddressLine2"
                      label="Billing address"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Enter Billing area",
                      //   },
                      // ]}
                      disabled={getData?.status?.toLowerCase() === "approved"}
                    />
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <PinCodeValidator
                      formName={"postalCodeBilling"}
                      label={"Billing Address Pincode"}
                      disabled={getData?.status?.toLowerCase() === "approved"}
                    />
                  </Col>
                </>
              ) : null}
            </Row>
            <hr className="divider" />
            <div className="flex-end mt-1">
              <Button className="cancel-btn ml-1 w-15" onClick={goBackStep}>
                BACK
              </Button>
              {getData?.status?.toLowerCase() === "approved" ? (
                <Button
                  id="saveNContinue"
                  onClick={() => handleStepsChange()}
                  className="save-btn  ml-1"
                >
                  NEXT
                </Button>
              ) : (
                <Button
                  onClick={form.submit}
                  className="save-btn w-15 ml-1"
                  // onClick={handleStepsChange}
                >
                  CONTINUE
                </Button>
              )}
            </div>
          </Form>
        </div>
      </div>
    </Spin>
  );
};

export default OrganisationDetails;
